import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { getConnection, getCurrentUser, getErrorMessage, hideSpinner, ignoreLetters, ignoreSpecialCharacters, showSpinner } from 'src/app/core/services/functions.service';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { ModuloMenu } from 'src/app/core/services/menu.service';
import { RequestsService } from 'src/app/core/services/requests.service';
import { environment } from 'src/environments/environment';
import { map, startWith } from 'rxjs/operators';
import { UsuariosService } from '../../../config/services/usuarios.service';
import { arrayNotEmpty, isNotEmpty } from 'class-validator';
import { UsuarioSicfModel } from '../../../config/models/user.model';
import { UsuarioAuth } from 'src/app/modules/auth/models/auth.models';
import { MatDialog } from '@angular/material/dialog';
import { UsuariosRolesComponent } from './usuarios-roles/usuarios-roles.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-usuarios',
  templateUrl: './usuarios.component.html',
  styleUrls: ['./usuarios.component.scss']
})
export class UsuariosComponent implements OnInit {

  users: any[] = []
  selectedUser: UsuarioSicfModel | undefined
  agencies: { c_age, nom }[] = []
  form: FormGroup
  icons: string[] = []

  constructor(
    private usuariosService: UsuariosService,
    private helpers: HelpersService,
    private formBuilder: FormBuilder,
    protected dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
  ) {
    this.form = this.formBuilder.group({
      nombre_usuario: ["", [Validators.maxLength(255)]],
      usuario_aplicativo: ["", [Validators.required, Validators.maxLength(30)]],
      clave_encriptada: ["", [Validators.minLength(6), Validators.maxLength(20)]],
      correo: ["", [Validators.maxLength(255), Validators.email]],
      celular: ["", [Validators.maxLength(255)]],
      estado: ["", [Validators.maxLength(255)]],
      c_age_trabajo: ["", [Validators.maxLength(255)]],

    })
    this.resetForm()
  }

  async ngOnInit() {
    const data = this.activatedRoute.snapshot.data
    if (data.title) {
      this.helpers.setTitle(data.title);
    }
    showSpinner()
    await this.getAllUsers()
    await this.getIcons()
    await this.getAgencies()
    hideSpinner()
  }

  async getIcons() {
    try {
      this.icons = await this.helpers.getIcons()
    } catch (error) {
      const message = getErrorMessage(error)
      this.helpers.notifications.errorMessage(message)
    }
  }

  async getAgencies() {
    showSpinner()
    try {
      const result = await this.usuariosService.findAllAgencies()
      this.agencies = result.data
    } catch (error) {
      const message = getErrorMessage(error)
      this.helpers.notifications.errorMessage(message)
    }
    hideSpinner()
  }

  resetForm(selectedUser: UsuarioSicfModel | undefined = undefined) {
    if (selectedUser == undefined) {
      this.selectedUser = undefined
      this.form.reset()
    } else {
      this.form.get("nombre_usuario")?.setValue(selectedUser?.nombre_usuario?.toUpperCase());
      this.form.get("usuario_aplicativo")?.setValue(selectedUser?.usuario_aplicativo);
      this.form.get("clave_encriptada")?.setValue("");
      this.form.get("correo")?.setValue(selectedUser?.correo?.toUpperCase());
      this.form.get("celular")?.setValue(selectedUser?.celular?.toUpperCase());
      this.form.get("estado")?.setValue(selectedUser?.estado?.toUpperCase());
      this.form.get("c_age_trabajo")?.setValue(selectedUser?.c_age_trabajo);
    }
  }

  async getAllUsers() {
    showSpinner()
    try {
      const result = await this.usuariosService.findAll()
      if (result.success) {
        this.users = result.data
      } else {
        this.helpers.notifications.errorMessage(result.message)
      }
    } catch (error) {
      const message = getErrorMessage(error)
      this.helpers.notifications.errorMessage(message)
    }
    hideSpinner()
  }

  async getOneUser(usuario_aplicativo: string) {
    try {
      const result = await this.usuariosService.findOne(usuario_aplicativo)
      if (result.success) {
        return result.data
      } else {
        this.helpers.notifications.errorMessage(result.message)
        return null
      }
    } catch (error) {
      const message = getErrorMessage(error)
      this.helpers.notifications.errorMessage(message)
      return null
    }
  }

  async selectUser(selected: any[]) {
    showSpinner()
    if (arrayNotEmpty(selected) && selected[0].usuario) {
      this.selectedUser = undefined
      this.selectedUser = await this.getOneUser(selected[0].usuario)
      if (this.selectedUser?.usuario_aplicativo) {
        this.resetForm(this.selectedUser)
      }
    }
    hideSpinner()
  }

  async create() {
    showSpinner()
    if (this.form.valid) {
      const result = await this.usuariosService.create(this.form.value)
      if (result.success) {
        await this.getAllUsers()
        this.helpers.notifications.successMessage(result.message)
      } else {
        this.helpers.notifications.errorMessage(result.message)
      }
      hideSpinner()
    } else {
      hideSpinner()
      this.helpers.notifications.errorMessage("Debe completar algunos campos nombre, usuario, estado, y clave")
    }
  }

  async modify() {
    showSpinner()
    if (this.form.valid && this.selectedUser && this.selectedUser.usuario_aplicativo) {
      const newValue: UsuarioAuth = {
        nombre_usuario: this.form.value.nombre_usuario,
        usuario_aplicativo: this.selectedUser.usuario_aplicativo,
        correo: this.form.value.correo,
        celular: this.form.value.celular,
        estado: this.form.value.estado,
        c_age_trabajo: this.form.value.c_age_trabajo,
        clave_encriptada: this.form.value.clave_encriptada
      }
      const result = await this.usuariosService.update(newValue)
      if (result.success) {
        await this.getAllUsers()
        this.helpers.notifications.successMessage(result.message)
      } else {
        this.helpers.notifications.errorMessage(result.message)
      }
      hideSpinner()
    } else {
      hideSpinner()
      this.helpers.notifications.errorMessage("Los campos de nombre, usuario y estado son obligatorios para modificar.")
    }
  }
  print(value) {
    return JSON.stringify(value)
  }
  ignoreSpecialCharactersVoid(controlName: string, value: string) {
    let hola = ignoreSpecialCharacters(value)
    this.form.get(controlName)?.setValue(hola)
    return hola
  }

  ignoreLettersVoid(controlName: string, value: string) {
    let hola = ignoreLetters(value)
    this.form.get(controlName)?.setValue(hola)
    return hola
  }

  openRolesDialog() {
    if (isNotEmpty(this.selectedUser?.usuario_aplicativo)) {
      const dialogRef = this.dialog.open(UsuariosRolesComponent, {
        data: this.selectedUser?.usuario_aplicativo,
        width: "100%",
        height: "70vh",
      });
    } else {
      this.helpers.notifications.infoMessage("Seleccione un usuario primero")
    }
  }
}

